// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pane.users-pane {
  text-align: left;
}
.pane.users-pane .users-options {
  margin: 0 1rem -0.5rem 0;
  padding: 0 1rem;
}
.pane.users-pane .users-options .label-text {
  margin: 0 0 0 0.5rem;
  width: unset;
}
.pane.users-pane .users-list {
  display: grid;
  grid-template-columns: auto 17.5rem;
  padding: 0;
}
.pane.users-pane .organization-group {
  background-color: var(--color-base-canvas);
  color: var(--color-base-text);
  font-size: 1.5rem;
  grid-column: span 2;
  margin-top: 2rem;
  padding: 1rem;
}
.pane.users-pane .empty-organization {
  color: var(--color-base-text);
  padding: 1rem;
}
.pane.users-pane .user-registration-send {
  float: right;
  margin: 1rem 0 0 1rem;
}
.pane.users-pane .user-registration-send-button {
  width: 14rem;
}
.pane.users-pane .user-registration-send-button.sending {
  color: var(--color-elevated-text);
  opacity: 1;
}
.pane.users-pane .user-card {
  border-top: var(--border-width) solid transparent;
  border-bottom: var(--border-elevated);
  display: grid;
  grid-column: span 2;
  grid-template-columns: subgrid;
  margin-top: calc(-1 * var(--border-width));
  padding: 0.8rem 1rem 1.1rem 1rem;
  text-align: right;
}
.pane.users-pane .user-card:first-child {
  border-top-color: var(--color-elevated-border);
  margin-top: 1rem;
}
.pane.users-pane .user-card.archived .user-card-inputs, .pane.users-pane .user-card.archived .user-registration-send-button, .pane.users-pane .user-card.archived .user-card-aqumen-id {
  opacity: 0.3;
}
.pane.users-pane .user-card.confirming-archive input.user-email, .pane.users-pane .user-card.confirming-archive input.user-full-name, .pane.users-pane .user-card.confirming-archive select.user-organization-select, .pane.users-pane .user-card.confirming-archive .user-timestamps-tile, .pane.users-pane .user-card.confirming-archive .label-text {
  color: var(--color-elevated-warn) !important;
}
.pane.users-pane .user-card.confirming-archive .user-card-meta .user-card-ids .data-label, .pane.users-pane .user-card.confirming-archive .user-card-meta .user-card-ids .display-id {
  color: var(--color-elevated-warn) !important;
  opacity: 1;
}
.pane.users-pane .user-card.new {
  border-top: var(--border-elevated);
  font-size: 0.9rem;
  margin-top: 1.5rem;
}
.pane.users-pane .user-card.new.confirming {
  border-color: var(--color-elevated-warn);
}
.pane.users-pane .user-card.new.confirming button.user-create-and-send {
  color: var(--color-elevated-warn);
  font-weight: bold;
}
.pane.users-pane .user-card.new:has(:focus-within) .user-card-inputs .label-text, .pane.users-pane .user-card.new.confirming .user-card-inputs .label-text {
  opacity: 1;
}
.pane.users-pane .user-card.new:has(:focus-within) textarea.user-additional-message, .pane.users-pane .user-card.new.confirming textarea.user-additional-message {
  border-color: rgb(108, 108, 112) !important;
}
.pane.users-pane .user-card.new .user-card-inputs input.user-email, .pane.users-pane .user-card.new .user-card-inputs input.user-full-name, .pane.users-pane .user-card.new .user-card-inputs textarea.user-additional-message {
  margin-left: 1rem;
  width: calc(100% - 7.5rem);
}
.pane.users-pane .user-card.new .user-card-inputs .user-organization-tile select.user-organization-select {
  width: calc(100% - 6.3rem);
}
.pane.users-pane .user-card.new .user-card-inputs textarea.user-additional-message {
  margin-top: 1rem;
  position: relative;
  vertical-align: top;
  width: calc(100% - 7.3rem);
}
.pane.users-pane .user-card.new .user-card-inputs .label-text {
  display: inline-block;
  width: unset;
}
.pane.users-pane .user-card.new button.user-create-and-send {
  width: 18rem;
}
.pane.users-pane .user-card.new .user-card-meta .user-card-actions {
  margin-top: 0;
}
.pane.users-pane .user-card.new .user-card-action:not(:first-child) {
  margin-top: 1rem;
}
.pane.users-pane .user-card .user-timestamps-tile {
  color: var(--color-base-text);
  line-height: 1.3rem;
}
.pane.users-pane .user-card .user-card-inputs {
  grid-column: 1;
  margin-left: -0.2rem;
  min-width: 20rem;
}
.pane.users-pane .user-card .user-card-inputs label.user-email, .pane.users-pane .user-card .user-card-inputs label.user-full-name, .pane.users-pane .user-card .user-card-inputs label.user-additional-message {
  display: block;
}
.pane.users-pane .user-card .user-card-inputs .label-text {
  display: none;
}
.pane.users-pane .user-card .user-card-inputs .user-email.label-text {
  display: unset;
}
.pane.users-pane .user-card .user-card-inputs input.user-email, .pane.users-pane .user-card .user-card-inputs input.user-full-name, .pane.users-pane .user-card .user-card-inputs textarea.user-additional-message {
  background-color: var(--color-elevated-canvas);
  margin-top: 0.5rem;
}
.pane.users-pane .user-card .user-card-inputs input.user-email:focus, .pane.users-pane .user-card .user-card-inputs input.user-full-name:focus, .pane.users-pane .user-card .user-card-inputs textarea.user-additional-message:focus {
  background-color: var(--color-elevated-input);
}
.pane.users-pane .user-card .user-card-inputs input.user-email {
  width: calc(100% - 22.5rem);
  margin-left: 1rem;
}
.pane.users-pane .user-card .user-card-inputs textarea.user-additional-message {
  width: calc(100% - 7.5em);
  margin-left: 1rem;
}
.pane.users-pane .user-card .user-card-inputs input.user-full-name {
  width: calc(100% - 1.5rem);
  margin-left: 0;
}
.pane.users-pane .user-card .user-card-inputs input.user-email {
  margin-top: 1rem;
}
.pane.users-pane .user-card .user-card-inputs input.user-email:focus {
  opacity: 1;
}
.pane.users-pane .user-card .user-card-inputs input.user-full-name {
  font-size: 1.1rem;
}
.pane.users-pane .user-card .user-card-inputs .user-organization-tile {
  text-align: left;
}
.pane.users-pane .user-card .user-card-inputs .user-organization-tile .label-text {
  display: unset;
}
.pane.users-pane .user-card .user-card-inputs .user-organization-tile select.user-organization-select {
  margin: 1rem 0 0 1rem;
  width: calc(100% - 21.2rem);
}
.pane.users-pane .user-card .user-archive, .pane.users-pane .user-card .user-registration-send {
  display: inline-block;
}
.pane.users-pane .user-card .user-card-meta {
  padding-top: 0.5rem;
  grid-column: 2;
}
.pane.users-pane .user-card .user-card-meta .user-card-ids {
  height: 5.25rem;
}
.pane.users-pane .user-card .user-card-meta .user-card-actions {
  margin-top: 0.85rem;
  text-align: right;
}
.pane.users-pane .user-card .user-card-meta .user-card-actions .confirming .user-archive-button, .pane.users-pane .user-card .user-card-meta .user-card-actions .confirming .user-unarchive-button {
  color: var(--color-elevated-warn);
}
.pane.users-pane .user-card .user-card-meta .user-card-actions .user-archive-button, .pane.users-pane .user-card .user-card-meta .user-card-actions .user-unarchive-button {
  margin-left: 1rem;
  width: 7rem;
}`, "",{"version":3,"sources":["webpack://./src/style/panes/access_control/access_control_users.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,wBAAA;EACA,eAAA;AACJ;AACI;EACE,oBAAA;EACA,YAAA;AACN;AAGE;EACE,aAAA;EACA,mCAAA;EACA,UAAA;AADJ;AAKE;EACE,0CAAA;EACA,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAHJ;AAME;EACE,6BAAA;EACA,aAAA;AAJJ;AAME;EACE,YAAA;EACA,qBAAA;AAJJ;AAME;EACE,YAAA;AAJJ;AAKI;EACE,iCAAA;EACA,UAAA;AAHN;AAOE;EACE,iDAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0CAAA;EACA,gCAAA;EACA,iBAAA;AALJ;AAOI;EACE,8CAAA;EACA,gBAAA;AALN;AASM;EACE,YAAA;AAPR;AAcQ;EAEE,4CAAA;AAbV;AAiBQ;EACE,4CAAA;EACA,UAAA;AAfV;AAoBI;EACE,kCAAA;EACA,iBAAA;EACA,kBAAA;AAlBN;AAoBM;EACE,wCAAA;AAlBR;AAoBQ;EACE,iCAAA;EACA,iBAAA;AAlBV;AAuBQ;EACE,UAAA;AArBV;AA0BQ;EACE,2CAAA;AAxBV;AA6BQ;EACE,iBAAA;EACA,0BAAA;AA3BV;AA6BQ;EACE,0BAAA;AA3BV;AA8BQ;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;AA5BV;AA+BQ;EACE,qBAAA;EACA,YAAA;AA7BV;AAiCM;EACE,YAAA;AA/BR;AAkCM;EACE,aAAA;AAhCR;AAmCM;EACE,gBAAA;AAjCR;AAqCI;EACE,6BAAA;EACA,mBAAA;AAnCN;AAsCI;EACE,cAAA;EACA,oBAAA;EACA,gBAAA;AApCN;AAsCM;EACE,cAAA;AApCR;AAsCM;EACE,aAAA;AApCR;AAsCM;EACE,cAAA;AApCR;AAuCM;EACE,8CAAA;EACA,kBAAA;AArCR;AAsCQ;EACE,6CAAA;AApCV;AAyCM;EACE,2BAAA;EACA,iBAAA;AAvCR;AA0CM;EACE,yBAAA;EACA,iBAAA;AAxCR;AA4CM;EACE,0BAAA;EACA,cAAA;AA1CR;AA6CM;EACE,gBAAA;AA3CR;AA4CQ;EACE,UAAA;AA1CV;AA8CM;EACE,iBAAA;AA5CR;AA+CM;EACE,gBAAA;AA7CR;AA+CQ;EACE,cAAA;AA7CV;AA+CQ;EACE,qBAAA;EACA,2BAAA;AA7CV;AAkDI;EACE,qBAAA;AAhDN;AAmDI;EACE,mBAAA;EACA,cAAA;AAjDN;AAmDM;EACE,eAAA;AAjDR;AAsDM;EACE,mBAAA;EACA,iBAAA;AApDR;AAuDU;EACE,iCAAA;AArDZ;AAyDQ;EACE,iBAAA;EACA,WAAA;AAvDV","sourcesContent":[".pane.users-pane {\n  text-align: left;\n\n  .users-options {\n    margin: 0 1rem -0.5rem 0;\n    padding: 0 1rem;\n\n    .label-text {\n      margin: 0 0 0 0.5rem;\n      width: unset;\n    }\n  }\n\n  .users-list {\n    display: grid;\n    grid-template-columns: auto 17.5rem;\n    padding: 0;\n  }\n\n\n  .organization-group {\n    background-color: var(--color-base-canvas);\n    color: var(--color-base-text);\n    font-size: 1.5rem;\n    grid-column: span 2;\n    margin-top: 2rem;\n    padding: 1rem;\n  }\n\n  .empty-organization {\n    color: var(--color-base-text);\n    padding: 1rem;\n  }\n  .user-registration-send {\n    float: right;\n    margin: 1rem 0 0 1rem;\n  }\n  .user-registration-send-button {\n    width: 14rem;\n    &.sending {\n      color: var(--color-elevated-text);\n      opacity: 1;\n    }\n  }\n\n  .user-card {\n    border-top: var(--border-width) solid transparent;\n    border-bottom: var(--border-elevated);\n    display: grid;\n    grid-column: span 2;\n    grid-template-columns: subgrid;\n    margin-top: calc(-1 * var(--border-width));\n    padding: 0.8rem 1rem 1.1rem 1rem;\n    text-align: right;\n\n    &:first-child {\n      border-top-color: var(--color-elevated-border);\n      margin-top: 1rem;\n    }\n\n    &.archived {\n      .user-card-inputs, .user-registration-send-button, .user-card-aqumen-id {\n        opacity: 0.3;\n      }\n    }\n\n    &.confirming-archive {\n      // border-color: var(--color-elevated-warn) !important;\n      // .user-card-inputs {\n        input.user-email, input.user-full-name, select.user-organization-select, .user-timestamps-tile, .label-text {\n          // border-color: var(--color-elevated-warn);\n          color: var(--color-elevated-warn) !important;\n        // }\n      }\n      .user-card-meta .user-card-ids {\n        .data-label, .display-id {\n          color: var(--color-elevated-warn) !important;\n          opacity: 1;\n        }\n      }\n    }\n\n    &.new {\n      border-top: var(--border-elevated);\n      font-size: 0.9rem;\n      margin-top: 1.5rem;\n\n      &.confirming {\n        border-color: var(--color-elevated-warn);\n\n        button.user-create-and-send {\n          color: var(--color-elevated-warn);\n          font-weight: bold;\n        }\n      }\n\n      &:has(:focus-within), &.confirming {\n        .user-card-inputs .label-text {\n          opacity: 1.0;\n        }\n\n        // FIXME Anything less than this specificity is being overriden somewhere\n        // that the browser inspector is not reporting.\n        textarea.user-additional-message {\n          border-color: rgb(108, 108, 112) !important;\n        }\n      }\n\n      .user-card-inputs {\n        input.user-email, input.user-full-name, textarea.user-additional-message {\n          margin-left: 1rem;\n          width: calc(100% - 7.5rem);\n        }\n        .user-organization-tile select.user-organization-select {\n          width: calc(100% - 6.3rem);\n        }\n\n        textarea.user-additional-message {\n          margin-top: 1rem;\n          position: relative;\n          vertical-align: top;\n          width: calc(100% - 7.3rem);\n        }\n\n        .label-text {\n          display: inline-block;\n          width: unset;\n        }\n      }\n\n      button.user-create-and-send {\n        width: 18rem;\n      }\n\n      .user-card-meta .user-card-actions {\n        margin-top: 0;\n      }\n\n      .user-card-action:not(:first-child) {\n        margin-top: 1rem;\n      }\n    }\n\n    .user-timestamps-tile {\n      color: var(--color-base-text);\n      line-height: 1.3rem;\n    }\n\n    .user-card-inputs {\n      grid-column: 1;\n      margin-left: -0.2rem;\n      min-width: 20rem;\n\n      label.user-email, label.user-full-name, label.user-additional-message {\n        display: block;\n      }\n      .label-text {\n        display: none;\n      }\n      .user-email.label-text {\n        display: unset;\n      }\n\n      input.user-email, input.user-full-name, textarea.user-additional-message {\n        background-color: var(--color-elevated-canvas);\n        margin-top: 0.5rem;\n        &:focus {\n          background-color: var(--color-elevated-input);\n        }\n      }\n\n\n      input.user-email {\n        width: calc(100% - 22.5rem);\n        margin-left: 1rem;\n      }\n\n      textarea.user-additional-message {\n        width: calc(100% - 7.5em);\n        margin-left: 1rem;\n      }\n\n\n      input.user-full-name {\n        width: calc(100% - 1.5rem);\n        margin-left: 0;\n      }\n\n      input.user-email {\n        margin-top: 1rem;\n        &:focus {\n          opacity: 1.0;\n        }\n      }\n\n      input.user-full-name {\n        font-size: 1.1rem;\n      }\n\n      .user-organization-tile {\n        text-align: left;\n\n        .label-text {\n          display: unset;\n        }\n        select.user-organization-select {\n          margin: 1rem 0 0 1rem;\n          width: calc(100% - 21.2rem);\n        }\n      }\n    }\n\n    .user-archive, .user-registration-send {\n      display: inline-block;\n    }\n\n    .user-card-meta {\n      padding-top: 0.5rem;\n      grid-column: 2;\n\n      .user-card-ids {\n        height: 5.25rem;\n      }\n\n\n\n      .user-card-actions {\n        margin-top: 0.85rem;\n        text-align: right;\n\n        .confirming {\n          .user-archive-button, .user-unarchive-button {\n            color: var(--color-elevated-warn);\n          }\n        }\n\n        .user-archive-button, .user-unarchive-button {\n          margin-left: 1rem;\n          width: 7rem;\n        }\n\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
